export function calculateMaxCapacity (dUnits,vUnits,Height, Width, Diameter, Length, Shape)
{
  var capacity;
  var lHeight, lWidth, lDiameter, lLength;
  const num_pi = 3.14159265359
  
  if (Shape === "horizontal"){
    if (dUnits === "inches"){
      //Convert to cm
      lLength = parseFloat(Length) * 2.54;
      lDiameter = parseFloat(Diameter) * 2.54;
    }
    else if (dUnits ==="feet"){
      //Convert to cm
      lLength = parseFloat(Length) * 2.54 * 12.0;
      lDiameter = parseFloat(Diameter) * 2.54 * 12.0;
    }
    else{
      lLength = parseFloat(Length);
      lDiameter = parseFloat(Diameter);
    }
    capacity = num_pi * ( (lDiameter/2.0) **2) * lLength / 1000;
  }
  else if (Shape === "obround"){
    if (dUnits === "inches"){
      //Convert to cm
      lLength = parseFloat(Length) * 2.54;
      lWidth = parseFloat(Width) * 2.54;
      lHeight = parseFloat(Height) * 2.54;
    }
    else if (dUnits ==="feet"){
      //Convert to cm
      lLength = parseFloat(Length) * 2.54 * 12.0;
      lWidth = parseFloat(Width) * 2.54 * 12.0;
      lHeight = parseFloat(Height) * 2.54 * 12.0;
    }
    else{
      lLength = parseFloat(Length);
      lWidth = parseFloat(Width);
      lHeight = parseFloat(Height);
    }
    capacity = (num_pi * ( (lWidth/2.0) **2) + (lHeight-lWidth)*lWidth)*lLength / 1000; //L
  }
  else{
    capacity = 0.0;
  }
  if (vUnits === "gallons"){
    //convert to gallons from L
    capacity = capacity * 0.264172;
  }
  return capacity.toFixed(1)
}